import { Component, Input } from '@angular/core';
import { InfoCardContainerRendering } from '@legacy/common-ui-models';
import { InfoCardComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-info-card-container',
  templateUrl: './info-card-container.component.html',
  styleUrls: [],
  standalone: true,
  imports: [InfoCardComponent],
})
export class InfoCardContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InfoCardContainerRendering;

  get button() {
    const { Button } = this.rendering?.fields || {};
    const { text, href } = Button?.value || {};
    return text && href ? Button : undefined;
  }
}
